import { useBeforeUnload } from "./useBeforeUnload";
import { useBlockNavigation } from "./useBlockNavigation";

type UsePreventLeaveSiteOptions = {
  isEnabled?: boolean;
};

export function usePreventLeaveSite({ isEnabled = true }: UsePreventLeaveSiteOptions = {}) {
  useBeforeUnload({ isEnabled });
  useBlockNavigation({ isEnabled });
}
